module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hidden-md-up"
  }, [_c('sidebar-current-issue'), _vm._v(" "), _c('sidebar-signup-button')], 1), _vm._v(" "), (_vm.topArticle.ids) ? _c('full-issue', {
    attrs: {
      "issue": _vm.topArticle
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('sidebar-quick-links'), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Impact Factor / Index / Archive:"
    }
  }, [_c('div', {
    staticClass: "sidebar-block-content"
  }, [_vm._v("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet. Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.")])])], 1), _vm._v(" "), _c('sections-beyond-oncology'), _vm._v(" "), _c('special-collection-archives'), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": ("Top 5 " + _vm.siteName + " Papers Rated by Altmetric Attention Score"),
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.issues), function(issue, index) {
    return (index < 5) ? _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue,
        "smallMode": index > 0 ? true : false
      }
    }) : _vm._e()
  }))]), _vm._v(" "), _c('title-block', {
    attrs: {
      "title": "Top 100 Papers from the Editorial Board",
      "link-title": "View All",
      "link-name": "",
      "color-theme": "primary-color"
    }
  }, [_c('div', _vm._l((_vm.top100issues), function(issue, index) {
    return _c('condensed-issue', {
      key: issue.id,
      attrs: {
        "issue": issue,
        "smallMode": index > 0 ? true : false
      }
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "hidden-md-up"
  }, [_c('sidebar-sponsorship')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cb66eb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/HomePage.vue
// module id = 1427
// module chunks = 1